export const NAV_WIDTH = 280;
export const NAV_COLLAPSED_WIDTH = 80;
export const NAV_HORIZONTAL_HEIGHT = 48;

export const HEADER_HEIGHT = 64;
export const MULTI_TABS_HEIGHT = 32;
